import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { DiscountMultiInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [
	"hotelID",
	"discountID",
	"isUncancelable",
	"saleTypeForPlan",
	"saleTypeForTerm",
	"stayableDayOfTheWeek",
	"multiDiscounts",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DiscountMultiFormModel = AutoGeneratorForFormModel<DiscountMultiInputZodSchemaType, ExcludeKeys, undefined>;
